import { memo } from 'react';
import { Text } from 'Text';

function LogoBoxHeaderComponent({ title, logo }: { title: string; logo: React.ReactNode }) {
    return (
        <div className="mb-3 flex items-start justify-between gap-3.5">
            <Text as="h3" weight="normal" color="black" className="text-lg">
                {title}
            </Text>
            <span className="-mt-[3px] h-7.5 w-7.5 shrink-0">{logo}</span>
        </div>
    );
}

export const LogoBoxHeader = memo(LogoBoxHeaderComponent) as typeof LogoBoxHeaderComponent;
